module.exports = __webpack_public_path__ + "img/bootstrap-4.68c0d35e.png";